<template>
<div>
    <div class="form-container ou-donation-form ncsymain">
        <div class="holder">
        
            <PaymentForm class="form-horizontal">
                  <section class="donate-programs__container" v-if="getValue('description') == 'Latte and Learning - One Session'">
                    <div class="donate-programs__title"><span>$100</span> - Latte and Learning - One Session</div>
                    <div class="donate-programs-info">
                        <img class="" src="https://res.cloudinary.com/ncsy/image/upload/c_scale,f_auto,q_auto,w_335/v1520319885/latte_thkhe1.jpg">
                        <p class="mission-item__excerpt"><strong>Latte &amp; Learning</strong> brings Judaism to local coffee shops and serves up Torah in a relaxed and fun environment. By meeting teens where they want to be, Latte &amp; Learning is the place for teens to ask real questions, voice their opinions and form a strong, non-pressured connection to their Judaism.</p>
                    </div>
                  </section>  
                  <section class="donate-programs__container" v-else-if="getValue('description') == 'Shabbaton - Sponsor a Teen'">
                            <div class="donate-programs__title"><span>$250</span> - Shabbaton - Sponsor a Teen</div>
                            <div class="donate-programs-info">
                                <img class="" src="https://res.cloudinary.com/ncsy/image/upload/c_scale,f_auto,q_auto,w_335/v1520319783/shabbaton_i0q79v.jpg">
                                <p class="mission-item__excerpt"><strong>Shabbaton weekends</strong> inspire and educate teens in an atmosphere of Jewish pride and growth. They provide an opportunity for public and yeshiva day school students to interact together in a traditional Shabbat environment while forming deep connections with advisors. Over these weekends, participants study Torah topics that speak directly to the high school mind. For many teens, these weekends are their first genuine Shabbat experience.</p>
                            </div>
                  </section>  
                  <section class="donate-programs__container" v-else-if="getValue('description') == 'Yarchei Kallah Scholarship'">
                            <div class="donate-programs__title"><span>$600</span> - Yarchei Kallah Scholarship</div>
                            <div class="donate-programs-info">
                                <img class="" src="https://res.cloudinary.com/ncsy/image/upload/c_scale,f_auto,q_auto,w_335/v1520319783/yarchei_kallah_ho6geo.jpg">
                                <p class="mission-item__excerpt"><strong>Yarchei Kallah</strong> is a five-day retreat that gives public school teens the opportunity to learn Torah during their winter break instead of going skiing or sitting on the beach. Traditional classroom learning is supplemented with group study, one-on-one learning, and late night discussions with teachers, advisors and fellow NCSYers. After a week of studying Torah, teens are imbued with a deep passion for learning more about their heritage.</p>
                            </div>
                  </section>  
                  <section class="donate-programs__container" v-else-if="getValue('description') == 'JUMP - Sponsor 5 Teens'">
                            <div class="donate-programs__title"><span>$1,000</span> - JUMP - Sponsor 5 Teens</div>
                            <div class="donate-programs-info">
                                <img class="" src="https://res.cloudinary.com/ncsy/image/upload/c_scale,f_auto,q_auto,w_335/v1520319779/jump_zxoecu.jpg">
                                <p class="mission-item__excerpt">Participants are given the tools and training to make positive changes in their schools and communities, while broadening their understanding of local and global issues facing the Jewish people today. <strong>JUMP (Jewish Unity Mentoring Program)</strong> is the NCSY National Leadership Program that trains and empowers high school students from all over the United States to become leaders.</p>
                            </div>
                  </section>  
                  <section class="donate-programs__container" v-else-if="getValue('description') == 'TJJ Sponsorship (Matched by the OU)'">
                            <div class="donate-programs__title"><span>$3,700</span> - TJJ Sponsorship (Matched by the OU)</div>
                            <div class="donate-programs-info">
                                <img class="" src="https://res.cloudinary.com/ncsy/image/upload/c_scale,f_auto,q_auto,w_335/v1520319949/tjj_us3qwy.jpg">
                                <p class="mission-item__excerpt"><strong>TJJ</strong> (The Jerusalem Journey) an incredible opportunity for public school teens to see Israel, explore, connect and be inspired by their Jewish heritage. While TJJ is fun and exciting, it also builds Jewish identity and a connection to the land of Israel through visits to the Western Wall and Masada, where participants see the living story of the Jewish people. Participants return with an increased passion for Judaism and a commitment to serve as leaders in their community.</p>
                            </div>
                  </section>  
                  <section class="donate-programs__container" v-else-if="getValue('description') == 'gap year scholarship'">
                            <div class="donate-programs__title"><span>$10,000</span> - Gap Year Scholarship for Public School Teen</div>
                            <div class="donate-programs-info">
                                <img class="" src="https://res.cloudinary.com/ncsy/image/upload/c_scale,f_auto,q_auto,w_335/v1520319778/gap_year_ymbyma.jpg">
                                <p class="mission-item__excerpt">Every year, <strong>NCSY</strong> provides over $1.5 million in scholarships for NCSYers who want to spend time in Israel on a gap year program in yeshiva, seminary or university. Through their gap year experience the trajectory of jewish identification and connection are improved.</p>
                            </div>
                  </section>  
                <div v-else>
                      <FormSection title="Donation Amount">
                        <div style="position:relative">
                            <AmountSelector/>                    
                            <ErrorLabel field="amount"  style="text-align:right"/>
                        </div>                    
                    </FormSection>
                    <FormSection v-if="form.amount">
                      <TransactionFee />
                    </FormSection>
                    <FormSection title="Donation Frequency">
                      <div class="frequency">
                        <PaymentOptions addMonthly monthesSelector/>
                      </div>
                    </FormSection>
                    <FormSection title="Donation Designation">
                      <NcsyDesignation />
                      <!-- <div class="cad-note" v-if="getValue('custom.subDesignation') == 'Canada' || getValue('custom.subDesignation') == 'Canada Dinner'">Please note this is in US dollars and US tax-receipts will be provided. For $CAD, visit <a href="https://canada.ncsy.org">https://canada.ncsy.org</a></div> -->
                   </FormSection>                
                </div>
                <FormSection>
                  <InHonorOf />
                </FormSection>
                <FormSection title="Personal Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                           
                </FormSection>
                <FormSection title="Billing Information">
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton showAmount btnText="Donate Now"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { usePaymentForm } from '~/shared/use-payment-form';
import { defineComponent, watch } from "vue";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  setup() {
    const { getValue, settings, setValue, form } = usePaymentForm();


    const params = queryParams();

    if (params.program) {
      //@ts-ignore
      switch (params.program.toLowerCase()) {
        case "latte-and-learning":
            setValue('amount', '100');
            setValue("applications.0.campaign", "Latte and Leaning");
            setValue('description', 'Latte and Learning - One Session')
          break;
        case "shabbaton":
        setValue('amount', '250');
        setValue("applications.0.campaign", "General Donation");
        setValue('description', 'Shabbaton - Sponsor a Teen')
          break;
        case "yarchei-kallah":
        setValue('amount', '600');
        setValue("applications.0.campaign", "Yarchei Kallah");
        setValue('description', 'Yarchei Kallah Scholarship')
          break;
        case "jump":
        setValue('amount', '1000');
        setValue("applications.0.campaign", "NCSY JUMP");
        setValue('description', 'JUMP - Sponsor 5 Teens')
          break;
        case "tjj":
        setValue('amount', '3700');
        setValue("applications.0.campaign", "TJJ Scholarship");
        setValue('description', 'TJJ Sponsorship (Matched by the OU)')
          break;
        case "gap-year":
        setValue('amount', '10000');
        setValue("applications.0.campaign", "Torah Fund");
        setValue('description', 'gap year scholarship')
          break;
      }
    }



    watch(
      () => getValue("custom.designation"),
      (val) => {
        if (val == "Ben Zakkai Honor Society" || !val) {
          setValue("applications.0.department", "BenZakkai");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Yarchei Kallah" || !val) {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "Yarchei Kallah");
        } 
         else if(val == "JSU Expansion" || !val) {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "JSU Expansion");
        } 
         else if(val == "NCSY Summer" || !val) {
          setValue("applications.0.department", "NCSY_Summer");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Education Donation" || !val) {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "Education Donation");
        } 
        else if(val == "Innovation Lab" || !val) {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "Innovation Lab");
        } 
        else {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "General Donation");
          // setValue("applications.0.campaign", val);
        }
      }
    );



    watch(
      () => getValue("custom.subDesignation"),
      (val) => {
        if(val == "Alumni" || !val) {
          setValue("applications.0.department", "NCSY_Alumni");
          setValue("applications.0.campaign", "General Donation");
         } 
        else if(val == "Argentina" || !val) {
          setValue("applications.0.department", "NCSY_Argentina");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Atlanta" || !val) {
          setValue("applications.0.department", "NCSY_Atlanta");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Atlantic Seaboard" || !val) {
          setValue("applications.0.department", "NCSY_AtlanticSeaboard");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Canada" || !val) {
          setValue("applications.0.department", "NCSY_Canada");
          setValue("applications.0.campaign", "General Donation");
          setValue('gateway', 'SensePassCardknox')
        } 
        else if(val == "Canada Dinner" || !val) {
          setValue("applications.0.department", "NCSY_Canada");
          setValue("applications.0.campaign", "Gala Dinner");
          setValue('gateway', 'SensePassCardknox')
        } 
        else if(val == "Central East" || !val) {
          setValue("applications.0.department", "NCSY_CentralEast");
          setValue("applications.0.campaign", "General Donation");
          } 
        else if(val == "Chile" || !val) {
          setValue("applications.0.department", "NCSY_Chile");
          setValue("applications.0.campaign", "General Donation");
          } 
        else if(val == "Israel" || !val) {
          setValue("applications.0.department", "NCSY_Israel");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Midwest" || !val) {
          setValue("applications.0.department", "NCSY_Midwest");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Mexico" || !val) {
          setValue("applications.0.department", "NCSY_Mexico");
          setValue("applications.0.campaign", "General Donation");
          } 
        else if(val == "National" || !val) {
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "General Donation");
           } 
        else if(val == "New Jersey" || !val) {
          setValue("applications.0.department", "NCSY_Tristate");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "New York" || !val) {
          setValue("applications.0.department", "NCSY_Tristate");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "New England" || !val) {
          setValue("applications.0.department", "NCSY_NewEngland");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Oregon" || !val) {
          setValue("applications.0.department", "NCSY_Portland");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Southern" || !val) {
          setValue("applications.0.department", "NCSY_Southern");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "Southwest" || !val) {
          setValue("applications.0.department", "NCSY_Southwest");
          setValue("applications.0.campaign", "General Donation");
        } 
        else if(val == "West Coast" || !val) {
          setValue("applications.0.department", "NCSY_WestCoast");
          setValue("applications.0.campaign", "General Donation");
        } 
        else {
          setValue("applications.0.department", "NCSY_Summer");
          setValue("applications.0.campaign", val);
        }
      }
    );


    return {
       form,
      getValue,
      settings,
      setValue,
    }
  },
})
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;
}
::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #1aa8d3;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
}

::v-deep .styled-radio--ou-donation.styled-radio .radio-part {
  @media (min-width: 720px) {
    min-width: 33.3%;
    flex: 1;
    max-width: 33.3%;
  }
}

.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}

.cad-note{
  display: block;
  line-height: normal;
  font-size: 12px;
    font-style: italic;

    a{
      color: #1aa8d3;
      &:hover{
        color: #12728f;
      text-decoration: underline;
      }
    }
}

.donate-programs__container{
    background: #ffeb3b14;
    border: 1px solid #ff98004f;
    padding: 0px 20px;
    border-radius: 2px;
}

.donate-programs-info{
    display: block;
    overflow: hidden;
    font-size: 15px;
}

.donate-programs-info img{
    display: block;
    width: 130px; /* you can use % */
    height: auto;
    vertical-align: middle;
    float: left;
    margin-right: 15px;
}

.mission-item__excerpt{
    font-size: 13px;
    min-width: 300px;
    max-width: 400px;
    color: black;
    float: none;
    line-height: 150%;
    margin-bottom: 24px;
}
.donate-programs__container {
    background: #ffeb3b14;
    border: 1px solid #ff98004f;
    padding: 0px 20px;
    border-radius: 2px;
}
.donate-programs__title {
    font-weight: bold;
    font-size: 19px;
    margin-bottom: 7px;
    margin-top: 25px;
}                       
</style>

